import { OfficeEventType, OfficeRow } from "services/api/offices/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const SETTING_OFFICES_SEARCH_COLUMNS: Column[] = [
  {
    title: "Naziv",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) => {
      return <>{row.name}</>;
    },
  },
  {
    title: "Adresa",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) => {
      const a = row.primaryAddress;
      if (!a) return <></>;
      return <>{[a.line1, a.postalCode, a.city].filter(Boolean).join(", ")}</>;
    },
  },
  {
    title: "Email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) => {
      return <>{row.primaryEmail?.emailAddress ?? ""}</>;
    },
  },
  {
    title: "Telefon",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) => {
      return <>{row.primaryPhone?.phoneNumber ?? ""}</>;
    },
  },
  {
    title: "",
    field: "type",
    type: ColumnTypes.custom,
    render: (row, onEventClick) => {
      return (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={() => onEventClick(row.id, OfficeEventType.REMOVE)}
          >
            Brisanje poslovnice
          </ButtonMenuItem>
        </ButtonMenu>
      );
    },
  },
];
